import { map } from 'lodash';
import { Storage } from '@ionic/storage';
import { parseGoal } from '@/goal';
import { parseHistory } from '@/goal/history';
import logger from '@/logger';
import dl, { keyFor } from '@/dataLayer';
const dlGoalKey = keyFor('goal');
const dlHistoryKey = keyFor('history');

//  for database schema changes
export default [
    async function initial(_meta, _version) {
        // nothing to do
    },
    async function upgradeToSQLite(_meta, _version) {
        //  create with default options
        //  will grab storage from IndexedDb or localstorage
        //  then we can store it in the new layer (in case it's SQLite now)
        const legacyDl = new Storage();
        await legacyDl.create();
        logger.log(`legacy storage:${legacyDl.driver}`);
        logger.log(`current storage:${dl.driver}`);

        await dl.set('goals', await legacyDl.get('goals'));
        await dl.set('options', await legacyDl.get('options'));
    },
    async function storeGoalsSeparately(_meta, _version) {
        const goals = map(await dl.get('goals'), JSON.parse);
        const keysOnly = map(goals, 'key');
        
        await Promise.all(map(goals, x => dl.set(dlGoalKey(x.key), x)));
        await dl.set('goals', keysOnly);
    },
    async function storeHistorySeparately(_meta, _version) {
        const keys = await dl.get('goals') ?? [];
        await Promise.all(map(keys, async key => {
            const goal = await dl.get(dlGoalKey(key));
            await Promise.all([
                dl.set(dlHistoryKey(key), parseHistory(goal.history)),
                dl.set(dlGoalKey(key), parseGoal(goal)),
            ]);
        }));
    },
    async function moveArchivedGoals(_meta, _version) {
        const keys = await dl.get('goals') ?? [];
        const archived = [];
        for (const key of keys) {
            const goal = parseGoal(await dl.get(dlGoalKey(key)));
            if (goal.archived)
                archived.push(key);
        }

        await dl.set('archive', archived);
    },
    async function fixBrokenArchive(_meta, _version) {
        const goalKeys = await dl.get('goals') ?? [];
        const archive = [];
        const badGoals = [];
        for (const key of goalKeys) {
            const goal = await dl.get(dlGoalKey(key));
            if (goal == null)
                badGoals.push(key);
            else if (goal.archived === true)
                archive.push(key);
        }

        for (const key of badGoals) {
            const index = goalKeys.indexOf(key);
            if (index >= 0)
                goalKeys.splice(index, 1);
        }
		
        console.log({ archive, goalKeys });

        await dl.set('archive', archive);
        await dl.set('goals', goalKeys);
    },
];